import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=a983094c&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=a983094c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a983094c",
  null
  
)

export default component.exports